import { styled } from "styled-components";

import { useSelector } from "common/utilities/react-redux";
import { getUserRole } from "domains/authentication/selectors";
import { AddKnowledgeButton } from "domains/topicDetail/components/actionButtons/AddKnowledgeButton";
import { AudioActionButton } from "domains/topicDetail/components/actionButtons/AudioActionButton";
import { BriefingActionButton } from "domains/topicDetail/components/actionButtons/BriefingActionButton";
import { DialogActionButton } from "domains/topicDetail/components/actionButtons/DialogActionButton";
import { EditActionButton } from "domains/topicDetail/components/actionButtons/EditActionButton";
import { EmbedMapActionButton } from "domains/topicDetail/components/actionButtons/EmbedMapActionButton";
import { FollowActionButton } from "domains/topicDetail/components/actionButtons/FollowActionButton";
import { RemoveMapActionButton } from "domains/topicDetail/components/actionButtons/RemoveMapActionButton";
import { ShareActionButton } from "domains/topicDetail/components/actionButtons/ShareActionButton";
import { getTmEditMode } from "domains/transformationMap/selectors";
import {
  getCanAccessCreate,
  getCanAccessDiscoverTopicDialogue,
  getCanFollowTopic,
} from "entities/permissions/selectors";
import type { Topic } from "entities/topics/types";

const StyledContainer = styled.div`
  margin: 1.5rem 0 1rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(70px, 1fr));
  justify-content: center;
  gap: 1rem;
`;

type TopicActionButtonsProps = { keyIssue?: Topic; topic: Topic };

export const TopicActionButtons = ({ topic, keyIssue }: TopicActionButtonsProps) => {
  const isEditing = useSelector(getTmEditMode);
  const hasAccessToDialog = useSelector(getCanAccessDiscoverTopicDialogue);
  const hasAccessToCreate = useSelector(getCanAccessCreate);
  const canFollow = useSelector(getCanFollowTopic);
  const userRole = useSelector(getUserRole);

  return (
    <StyledContainer>
      {topic.can_edit && hasAccessToCreate && <EditActionButton topicId={topic.id} />}
      {canFollow && (
        <FollowActionButton topicId={topic.id} topicName={topic.name} isFollowing={topic.is_following ?? false} />
      )}
      {!isEditing && (
        <>
          {userRole !== "Unauthenticated" && <BriefingActionButton />}
          {topic.attachment?.type === "podcast" && <AudioActionButton topicId={topic.id} />}
          {topic.is_shareable && <ShareActionButton topic={topic} keyIssue={keyIssue} />}
          {hasAccessToDialog && <DialogActionButton />}
        </>
      )}
      {topic.is_custom && <RemoveMapActionButton topic={topic} />}
      {!isEditing && <EmbedMapActionButton />}
      {!isEditing && <AddKnowledgeButton topicId={topic.id} />}
    </StyledContainer>
  );
};
